export default "__VITE_ASSET__HYJKm1zS__"